import { useAuth } from "@/context/AuthContext"
import { useGameWebNotifications } from "@/features/notifications/useGameWebNotifications"

export default function GameWebNotificationsBridge() {
  const { isAuthenticated } = useAuth()
  useGameWebNotifications(isAuthenticated)
  return null
}
